var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"presentation-set-collection"},[_c('easyscreen-content-switcher',{ref:"contentSwitcher",attrs:{"options":_vm.switcherOptions,"with-sound-control":false,"with-pause-control":false,"default-selected":_vm.defaultSelected},on:{"selected":_vm._onSelected}},[_c('div',{ref:"content",staticClass:"presentation-set-collection--content"},[_c('presentation-set',{ref:"presentationSet",style:({
          transform: `scale(${ _vm.scaleFactor })`,
          transformOrigin: 'top left',
          width: `${ 100 / _vm.scaleFactor }%`,
          height: `${ 100 / _vm.scaleFactor }%`
        }),attrs:{"with-top-bar":false,"with-duration-bar":false,"with-background":false,"slides":_vm.activeSlide.content}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }